<template>
  <div class="file-viewer">
    <iframe :src="this.src" />
  </div>
</template>

<script>
export default {
  name: "FileViewer",
  props: {
    post: {
      type: Object
    }
  },
  created() {
    this.src = this.post.file.source;
    // if (
    //   /([^\s]+(\.(doc|docx|xls|xlx|ppt|pptx))$)/i.test(this.post.file.fileName)
    // ) {
    //   this.src = `//view.officeapps.live.com/op/view.aspx?src=${this.post.file.source}`;
    // }
  }
};
</script>
